import { AddCircleIcon, SearchIcon } from '@approvalmax/ui';
import { Box, Button, Grid, Text } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import * as firstStart from 'modules/first-start';
import { FC, memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMount } from 'react-use';
import { getSupportSiteUrl } from 'urlBuilder';

import { messages } from './WhatYouCanDoNow.messages';
import { WhatYouCanDoNowProps } from './WhatYouCanDoNow.types';

export const WhatYouCanDoNow: FC<WhatYouCanDoNowProps> = memo((props) => {
    const { openNewOrgPopopOnMount } = props;

    const dispatch = useDispatch();

    const profile = useSelector(selectors.profile.getProfile);

    const userCanCreateOrganisation =
        profile.account?.userRole !== domain.AccountMemberRole.Member &&
        profile.account?.userRole !== domain.AccountMemberRole.UserManager;

    const onAddNewOrg = useCallback(() => {
        dispatch(
            firstStart.loadNewOrganisationSetup({
                fromNoCompanies: true,
            })
        );
    }, [dispatch]);

    useMount(() => {
        if (userCanCreateOrganisation && openNewOrgPopopOnMount) {
            onAddNewOrg();
        }
    });

    return (
        <Grid gap={16} width={480}>
            <Text font='label' fontSize='medium' color='midnight80'>
                {messages.title}
            </Text>

            <Grid gridTemplateColumns='auto auto' gap={16} justifyContent='center'>
                <Box bordered borderColor='midnight40' radius='small' width={232}>
                    <Button
                        block
                        noPadding
                        noUppercase
                        as='a'
                        target='_blank'
                        rel='noopener noreferrer'
                        color='white100'
                        variant='outline'
                        href={getSupportSiteUrl()}
                    >
                        <Grid padding='24 16' gap={8} justifyItems='center'>
                            <Text font='label' fontSize='small' color='midnight80'>
                                {messages.knowledge}
                            </Text>

                            <SearchIcon color='black100' />
                        </Grid>
                    </Button>
                </Box>

                {userCanCreateOrganisation && (
                    <Box bordered borderColor='midnight40' radius='small' width={232}>
                        <Button block noPadding noUppercase variant='outline' color='white100' onClick={onAddNewOrg}>
                            <Grid padding='24 16' gap={8} justifyItems='center'>
                                <Text font='label' fontSize='small' color='midnight80'>
                                    {messages.setup}
                                </Text>

                                <AddCircleIcon color='black100' />
                            </Grid>
                        </Button>
                    </Box>
                )}
            </Grid>
        </Grid>
    );
});

WhatYouCanDoNow.displayName = 'WhatYouCanDoNow';
